/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
const objectComponents = ['radio']
const arrayComponents = [ 'select-api', 'select-resource', 'select', 'checkbox']
const selectComponents = ['select', 'select-api', 'select-resource']

export const find = (list, f) => {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export const deepCopy = (obj, cache = []) => {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

/**
 * forEach for object
 */
export const forEachValue = (obj, fn) => {
  Object.keys(obj).forEach(key => fn(obj[key], key))
}

export const isObject = (obj) => {
  return obj !== null && typeof obj === 'object'
}

export const isPromise = (val) => {
  return val && typeof val.then === 'function'
}

export const assert = (condition, msg) => {
  if (!condition) throw new Error(`[vuex] ${msg}`)
}

export function isObjectComponent (component) {
  let result = false
  if (objectComponents.includes(component.type)) {
    if (!component.isMultiselect) {
      result = true
    }
  }
  return result
}

export function isArrayComponent (component) {
  let result = false
  if (arrayComponents.includes(component.type)) {
    result = true
  }
  if (selectComponents.includes(component.type)) {
    if (component.isMultiselect) {
      result = true
    }
  }
  return result
}

export function getTypeByComponent (component) {
  const objectComponents = ['radio']
  const arrayComponents = ['checkbox', 'select', 'select-api', 'select-resource' ]

  let type = 'String'
  if (arrayComponents.includes(component.type)) {
    type = 'Array'
  }
  if (objectComponents.includes(component.type)) {
    type = 'Object'
  }
  if (component.type === 'datepicker') {
    type = 'Data'
  }
  if (component.type === 'number') {
    type = 'Number'
  }
  return type
}
